import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link } from 'react-router-dom';
import UserAvatar from 'react-user-avatar';
import * as apiConfig from "../../api/config";
import moment from "moment"

const RouteView = ({ user, post, mode, onDeletePost }) => {
    useEffect(() => {

    }, [])

    function userPrefDistance() {
        if (user.preferredMeasurementUnits == 'Statute') {
            var dist = post.subjectData.distanceKm * 0.621371192; 
            dist = Math.round(dist * Math.pow(10, 2)) / Math.pow(10, 2)
            return `${dist} mi`;
        }
        return `${Math.round(post.subjectData.distanceKm * Math.pow(10, 2)) / Math.pow(10, 2)} km`;
    }

    function userPrefElevation() {
        if (user.preferredMeasurementUnits == 'Statute') {
            var ele = post.subjectData.elevationM * 3.2808399;
            ele = Math.round(ele * Math.pow(10, 2)) / Math.pow(10, 2)
            return `${ele} ft`;
        }
        return `${Math.round(post.subjectData.elevationM * Math.pow(10, 2)) / Math.pow(10, 2)} m`;
    }

    function getRouteCategoryBadge(category) {
        switch (category) {
            case "Road":
                return "/resources/images/road75.png";
            case "OffRoad":
                return "/resources/images/mtb75.png";
            case "Gravel":
                return "/resources/images/gravel75.png";
            default:
                return "/resources/images/road75.png"
        }
    }

    return (
        <div className="row subject-post route-subject-post">

            <div className="post-body col-md-12 col-lg-7 col-xl-6">
                <div className="post-header">
                    <div className="post-avatar">
                        {(user.id && user.id.toUpperCase() == post.authorId.toUpperCase()) ?
                            <UserAvatar size="50" name={`${user.firstName} ${user.surname}`} src={user.avatarAvailable ? `${apiConfig.API_URL}user/avatar/${user.id}.png?v=${user.avatarVersion}` : ""} />
                            :
                            <UserAvatar size="50" name={`${post.authorFirstName} ${post.authorSurname}`} src={post.authorHasAvatar ? `${apiConfig.API_URL}user/avatar/${post.authorId}.png` : ""} />
                        } 
                    </div>
                    <div className="post-details">
                        <div>
                            <Link className="float-left mr-1" to={`/user/profile/${post.authorId}`}>{`${post.authorFirstName} ${post.authorSurname}`}</Link>
                            <div className="float-left">{mode == "shared" ? "shared a route" : "uploaded a route"}</div>
                            {post.groupName &&
                                <React.Fragment>
                                    <span> with </span>
                                    <Link to={`/groups/${post.groupId}`}>{post.groupName}</Link>
                                </React.Fragment>
                            }
                        </div>
                        <div className="float-left"><small className="text-muted">{`Posted: ${moment(post.postedOn).format("DD MMMM")} at ${moment(post.postedOn).format("h:mm a")}`}</small></div>
                    </div>
                </div>
                <Link to={`/routes/${post.subjectData.id}`} >
                    <div className="route-details-container">
                        <div className="route-share-header">
                            <img className="route-share-category-image" src={getRouteCategoryBadge(post.subjectData.category)} alt={post.subjectData.category} />
                            <h5 className="card-title">{post.subjectData.name}</h5>
                            <ul className="route-share-details">
                                <li><small className="text-muted"><span className={'fas fa-route'}></span>Distance: {userPrefDistance()}</small></li>
                                <li><small className="text-muted"><span className={'fas fa-chart-line'}></span>Elevation: {userPrefElevation()}</small></li>
                            </ul>
                        </div>
                    </div>
                </Link>
            </div>
            <div className="col-md-12 col-lg-5 col-xl-6 post-image-container">
                <Link to={`/routes/${post.subjectData.id}`} >
                    <img className="card-img img-fluid" src={`${apiConfig.API_URL}routes/routepreview/${post.subjectData.id}.png?size=lrg`} alt={post.subjectData.name} />
                </Link>
                    {(user.id && user.id.toUpperCase() == post.authorId.toUpperCase()) &&
                        <div className="post-options">
                            <div className="dropdown">
                                <button className="btn btn-link post-options-btn" id="dLabel" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <span className="fas fa-ellipsis-h"></span>
                                </button>
                                <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dLabel">
                                    <a className="dropdown-item" onClick={onDeletePost} href="#">Delete Post</a>
                                </div>
                            </div>
                        </div>
                    }
                
            </div>

        </div>
    )
};


RouteView.propTypes = {
    user: PropTypes.object.isRequired,
    post: PropTypes.object.isRequired,
    mode: PropTypes.string.isRequired,
    onDeletePost: PropTypes.func.isRequired
}

function mapStateToProps(state) {
    return {
        user: state.user
    };
}

export default connect(mapStateToProps)(RouteView);





// WEBPACK FOOTER //
// ./src/components/postComments/SubjectDataRouteView.js